export const mutations = {
  logEvent (state, description) {
    state.log.events.push({
      time: Date.now(),
      description
    })
  },
  setCategoryExpanded (state, { id, expanded }) {
    for (const category of state.categories) {
      if (category.id === id) {
        category.defaultExpended = expanded
      }
    }
  },
  openDrawer (state) {
    state.drawer = true
  },
  closeDrawer (state) {
    state.drawer = false
  },
  openService (state) {
    state.modal = true
  },
  closeService (state) {
    state.modal = false
  },
  setActiveCategory (state, category) {
    state.activeCategory = category
  },
  clearActiveCategory (state) {
    state.activeCategory = null
  },
  setService (state, service) {
    state.service = service
  },
  selectService (state) {
    if (state.service.id !== undefined) {
      state.service.isSelected = true
    }
  },
  unselectService (state) {
    if (state.service.id !== undefined) {
      state.service.isSelected = false
    }
  },
  openReason (state) {
    state.reason = true
  },
  setReason (state, reasonId) {
    //if (state.service.id !== undefined) {
      state.service.declinedReasonId = reasonId
   // }
  },
  closeReason (state) {
    state.reason = false
  },
  openHelp (state) {
    state.help = true
  },
  closeHelp (state) {
    state.help = false
  },
  setSlug (state, slug) {
    state.log.clientId = slug
    state.slug = slug
  },
  clearError (state) {
    state.error = ''
  },
  setCode (state, code) {
    state.code = code
  },
  setLocale (state, locale) {
    try {
      const locales = Intl.getCanonicalLocales(locale)
      locale = locales[0]
    } catch (e) {}
    state.locale.selected = locale
  },
  setDefaultLocale (state, locale) {
    try {
      const locales = Intl.getCanonicalLocales(locale)
      locale = locales[0]
    } catch (e) {}
    state.locale.default = locale
  },
  setDealer (state, dealerContactInfo) {
    state.dealer = dealerContactInfo
  },
  setDmpiLinks (state, financingOptUrls) {
    state.dmpiLinks = financingOptUrls
  },
  setInspectionLevelMediaUrl (state, inspectionLevelMediaUrl) {
    state.inspectionLevelMediaUrl = inspectionLevelMediaUrl
  },
  setinspectionLevelMediaUrls (state, inspectionLevelMediaUrls) {
    state.inspectionLevelMediaUrls = inspectionLevelMediaUrls
  },
  setInspectionLevelMedia (state, inspectionLevelMedia) {
    state.inspectionLevelMedia = inspectionLevelMedia
  },
  setDisableDeclineReasons(state, isDisableDeclineReasons) {
    state.isDisableDeclineReasons = isDisableDeclineReasons
  },
  setReadOnly(state, isReadOnly) {
    state.isReadOnly = isReadOnly
  },
  setCompletedByAdvisor(state, isCompletedByAdvisor) {
    state.isCompletedByAdvisor = isCompletedByAdvisor
  },
  setCustomerSignature(state, customerSignature) {
    state.customerSignature = customerSignature
  },
  setGuestPaymentEnabled(state, isGuestPaymentEnabled) {
    state.isGuestPaymentEnabled = isGuestPaymentEnabled
  },
  setTopImageUrl (state, topImageUrl) {
    state.topImageUrl = topImageUrl
  },
  setExpired (state, expired) {
    state.expired = expired
  },
  setLanguages (state, supportedLanguages) {
    state.languages = supportedLanguages.map(language => ({
      culture: Intl.getCanonicalLocales(language.culture)[0],
      name: language.name
    }))
  },
  setCustomer (state, { firstName, lastName, isBusiness }) {
    state.customer = { firstName, lastName, isBusiness }
  },
  setCategories (state, serviceCategories) {
    state.categories = serviceCategories
  },
  setReasons (state, reasons) {
    state.reasons = reasons
  },
  setLoading (state, { key, loading }) {
    state.loading[key] = loading
  },
  setToken (state, token) {
    state.token = token
  },
  setCustomerCommentsLabel (state, label) {
    state.customerCommentsLabel = label
  },
  setServices (state, services) {
    state.services = services
  },
  setAdvisor (state, advisor) {
    state.advisor = advisor
  },
  setPreviouslyApprovedTax (state, tax) {
    if (typeof tax === 'number') {
      state.tax.previouslyApproved = tax
    }
  },
  setNewlyApprovedTax (state, tax) {
    if (typeof tax === 'number') {
      state.tax.newlyApproved = tax
    }
  },
  setCoreCharges (state, coreCharges) {
    if (typeof coreCharges === 'number') {
      state.tax.coreCharges = coreCharges
    }
  },
  setApprovedHazardousMaterialFee (state, hazardousMaterialFee) {
    if (typeof hazardousMaterialFee === 'number') {
      state.approvedHazardousMaterialFee = hazardousMaterialFee
    }
  },
  setHazardousMaterialsFee(state, fee) {
    if (typeof fee === 'number') {
      state.hazardousMaterialsFee = fee;
    }
  },
  setStripePaymentMethods (state, paymentMethods) {
    state.stripePaymentMethods = paymentMethods
  },
  setError (state, error) {
    if (state.supported) {
      state.error = error
    }
  },
  setSignature (state, signature) {
    state.signature = signature
  },
  setGuestPaymentSurchargeAmountOnline (state, amount) {
    state.guestPaymentSurchargeAmountOnline = amount
  },
  setGuestPaymentSurchargeAmountTerminal (state, amount) {
    state.guestPaymentSurchargeAmountTerminal = amount
  },
  setGuestPaymentSurchargeDisclaimer (state, disclaimer) {
    state.guestPaymentSurchargeDisclaimer = disclaimer
  },
  setGuestPaymentSurchargePriceBreakdown (state, isPriceBreakdown) {
    state.guestPaymentSurchargePriceBreakdown = isPriceBreakdown
  },
  setInspectionReportUrl (state, url) {
    state.inspectionReportUrl = url
  },
  acceptTermsAndConditions (state) {
    state.acceptedTermsAndConditions = true
  },
  declineTermsAndConditions (state) {
    state.acceptedTermsAndConditions = false
  },
  setRespondBy (state, deadline) {
    state.deadlines.respondBy = new Date(deadline)
  },
  setReadyBy (state, deadline) {
    state.deadlines.readyBy = new Date(deadline)
  },
  setDealerId (state, dealerIdValue) {
    state.dealerId = dealerIdValue
  }
}

export default mutations
